import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { forEach, isEmpty } from 'lodash';

import { Enums } from '../../../../../../configs/Enums';

export interface WorkShiftStatusIntervals {
  hours: number;
  minutes: number;
  int_type: number;
  int_name?: string;
}

@Component({
  selector: 'app-employee-worked',
  templateUrl: './employee-worked.component.html',
  styleUrls: ['./employee-worked.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EmployeeWorkedComponent implements OnChanges {
  Enums = Enums;
  moment = require('moment');
  intervals = {};

  @Input() worked;
  @Input() currentDate;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges) {
    this.handleUpdate();
  }

  handleUpdate() {
    if (!this.worked || isEmpty(this.worked)) {
      return;
    }

    forEach(this.worked, (intervals, int_type) => {
      let millis = 0;
      let interval: WorkShiftStatusIntervals = {
        hours: 0,
        minutes: 0,
        int_type: +int_type,
      };

      forEach(intervals, (int) => {
        millis += +new Date(int.int_end) - +new Date(int.int_begin);
      });

      let timeObj = millis ? this.moment.duration(millis) : undefined;

      if (typeof timeObj === 'object') {
        interval.hours = timeObj.hours();
        interval.minutes = timeObj.minutes();
      }

      this.intervals[Enums.workShiftIntervalStatuses[int_type]] = interval;
    });

    this.cdr.markForCheck();
  }
}
